import React from 'react';
import TituloPisoVinilicoLvt from '../components/sections/Piso-Vinilico-Lvt/TituloPisoVinilico-Lvt';
import IntroPisoVinilicoLVT from '../components/sections/Piso-Vinilico-Lvt/IntroPisoVinilico-Lvt';
import CatalogoPisoVinilicoLVT from '../components/sections/Piso-Vinilico-Lvt/CatalogoPisoVinilico-Lvt';
import BarraInfoNosotros from '../components/sections/BarraInfoNosotros';
import FormularioContactoLvt from '../components/sections/Piso-Vinilico-Lvt/FormularioContactoLvt';
import Header from '../components/layouts/Header';
import Footer from '../components/layouts/Footer';

const PisoVinilicoLvtPage = () => {
  return (
    <div>
      <Header />
       {/* Titulo */}
       <TituloPisoVinilicoLvt />

      <IntroPisoVinilicoLVT />
      
      <CatalogoPisoVinilicoLVT />
      
      <BarraInfoNosotros />

      <FormularioContactoLvt />
      
      <Footer />
    </div>
  );
};

export default PisoVinilicoLvtPage;
